import { InputGroup } from "@blueprintjs/core";
import { FieldProps } from "formik";
import { observer } from "mobx-react";
import { FileLink } from "modules/common/components/files/FileLink";
import { PercentInput } from "modules/common/components/form/PercentInput";
import { StandardFormInput } from "modules/common/components/form/StandardFormInput";
import { PlanRDndUploader } from "modules/common/components/planr/dndUploader/FileDndUploader";
import { onlyDigitsInputKeyPress } from "modules/common/services/form/values";
import React from "react";
import { Schema } from "yup";
import { ACCEPT, fields } from "../models/settings";
import styles from "./KpiSettings.module.scss";

const digits = onlyDigitsInputKeyPress();

class MobileBase extends React.PureComponent<MobileProps> {
  render() {
    const { schema, baseUrl, upload } = this.props;
    return (
      <div className="columns">
        <div className={styles.columns}>
          <div className={styles.column}>
            <StandardFormInput
              name={fields.appVersion}
              schema={schema}
              inline={false}
              small={true}
              className="planr-form-input"
            >
              {({ field }) => (
                <InputGroup
                  id={field.name}
                  className="planr-default-input"
                  {...field}
                  type="text"
                  autoComplete="off"
                  data-lpignore="true"
                />
              )}
            </StandardFormInput>

            <div className={styles.row}>
              <StandardFormInput name={fields.appFile} schema={schema} small={true} className="planr-form-input">
                {({ field, form }: FieldProps) => {
                  const onRemoveFile = (file: FileBase) => {
                    // Просто очищаем значение, так как это одиночный файл
                    form.setFieldValue(field.name, null);
                    form.setFieldTouched(field.name, true);
                  };

                  const onFileSelected = async (file: File) => {
                    const success = await upload(file);

                    if (success) {
                      // Заменяем значение на новый файл
                      form.setFieldValue(field.name, success);
                      form.setFieldTouched(field.name, true);
                    }
                  };

                  return (
                    <div className={styles.fileList}>
                      <label className="bp3-label">Прикрепить файл:</label>

                      <PlanRDndUploader
                        accept={ACCEPT}
                        onFileSelected={onFileSelected}
                        withLoader={true}
                        multiple={false}
                        style={{ width: "600px" }}
                      />
                      <div className={styles.filesList}>
                        {field.value && (
                          <FileLink
                            baseUrl={baseUrl}
                            file={field.value}
                            onRemove={onRemoveFile}
                            style={{ width: "600px", marginTop: "5px" }}
                          />
                        )}
                      </div>
                    </div>
                  );
                }}
              </StandardFormInput>
            </div>
          </div>
        </div>
      </div>
    );
  }

  fieldRenderer = ({ field, form }: FieldProps) => (
    <PercentInput
      onBlur={field.onBlur}
      id={field.name}
      name={field.name}
      value={field.value}
      className="planr-default-input"
      autoComplete="off"
      data-lpignore="true"
      onKeyPress={digits}
      onPercentChange={(p) => {
        form.setFieldValue(field.name, p.floatValue);
        form.setFieldTouched(field.name, true);
      }}
    />
  );
}

export const MobileSettings = observer(MobileBase);

interface MobileProps {
  schema: Schema<any>;
  baseUrl: string;
  upload: (file: File) => Promise<FileBase | null>;
}
